export interface Feature {
  icon: string;
  text: string;
}

export const featuresData: Feature[] = [
  {
    icon: '/jackpot/emoji/moneyBag.svg',
    text: 'features.realMoney',
  },
  {
    icon: '/jackpot/emoji/present.svg',
    text: 'features.growingPrize',
  },
  {
    icon: '/jackpot/emoji/slotMachine.svg',
    text: 'features.reward',
  },
  { icon: '/jackpot/emoji/wad.svg', text: 'features.credit' },
  {
    icon: '/jackpot/emoji/moneyEyes.svg',
    text: 'features.random',
  },
];
